// BackgroundGroup.js
import React from 'react';
import GroupComponent from './GroupComponent';

const BackgroundGroup = (props) => {
  return (
    <GroupComponent 
      {...props} 
      groupType="background" 
      actionSummary={props.actionSummary} 
    />
  );
};

export default BackgroundGroup;